import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup, FormControl } from '@angular/forms';
import { MixtureRowComponent } from '../mixture-row/mixture-row.component';

@Component({
	selector: 'app-mixture',
	templateUrl: './mixture.component.html',
	styleUrls: ['./mixture.component.scss']
})
export class mixtureComponent implements OnInit {
	@Input() public mixtureFormArray: FormArray;
	 @Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();
	 @Output() onFormChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() public qID: string;
	@Input() public displayErrors: boolean;

	maxArrayLength = 4;

	constructor() { }

	ngOnInit() {


		let d = this.mixtureFormArray;
		console.debug("mixtureComponent.ngOnInit()",this.mixtureFormArray);

	}

	emitChanges($event) {
		this.onFormChange.emit($event);
	}

	addrow() {
		// this.cycleMixureFormArray.push({});
		this.onAddFormGroup.emit();
		this.displayErrors = this.mixtureFormArray.invalid;

		// if (this.mixtureFormArray.valid) {
			this.mixtureFormArray.push(MixtureRowComponent.buildItem(''));
		// }
	}

	simulateClick(event) {
		if (event.keyCode === 13) {
			event.currentTarget.click();
		}
	}

	//build form array 1
	static build(value: any) {
		let arr: FormGroup[] = [];

		if (value && value[0][0].answerValue) {
			value.forEach(element => {
				arr.push(MixtureRowComponent.buildItem(element));
			});
		} else {
			arr.push(MixtureRowComponent.buildItem(''));
		}

		return new FormArray(arr);
	}
}



// WEBPACK FOOTER //
// ./src/app/mixture/mixture.component.ts